<template>
  <div id="customized_report">
    <div class="report-loader text-center mb-5" v-if="loading">
      <img src="/images/loading.gif" />
    </div>
    <div class="text-center" v-else-if="error">
      Sorry there has been an error. Please Contact ITR Support Test
    </div>
    <div v-else>
      <template v-if="!safarimobile">
        <div class="iframeEmbed insiderIframe--wrapper" id="google">
          <iframe class="insiderIframe" :src="'/' + pdf"></iframe>
        </div>
      </template>
      <template v-else>
        <!--use the google renderer-->
        <!-- <p><a :href="'/storage/' + report.downloads.pdf" class="button-green">Download PDF</a></p> -->
        <div class="iframeEmbed insiderIframe--wrapper" id="google">
          <iframe
            :src="
              'https://docs.google.com/viewer?url=' +
              app_url +
              '/' +
              pdf +
              '&embedded=true'
            "
            style="width: 100%; height: 100%"
            frameborder="0"
          ></iframe>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CustomizedReportComponent',
    props: ['apiID', 'app_url', 'reportID', 'toggleDisabledBit'],
    watch: {
      apiID: function (newVal, oldVal) {
        if (newVal != oldVal) {
          this.getPDF();
        }
      },
    },
    components: {},
    data: () => ({
      pdf: '',
      error: false,
      loading: true,
      customized_report_url: '',
      safarimobile:
        navigator.userAgent.match(/(iPod|iPhone|iPad)/) &&
        navigator.userAgent.match(/AppleWebKit/),
    }),
    mounted() {
      this.getPDF();
    },
    updated() {},
    methods: {
      getPDF: function () {
        this.loading = true;
        this.error = false;
        axios
          .get(`/consulting/customized-report/${this.apiID}/${this.reportID}`)
          .then((success) => {
            //returns success message when loading reports
            this.loading = false;
            if (success.data.success) {
              this.pdf = success.data.pdf;
              this.customized_report_url = success.data.customized_report_url;
              document.getElementById('customized-report-link').href =
                '/' + this.pdf;
            } else {
              this.error = true;
            }

            // ccb416
            this.$emit('toggleDisabledBit');
          })
          .catch((error) => {
            //in the .then we don't know if data is returned properly
            this.error = true;
            this.loading = false;

            // ccb416
            this.$emit('toggleDisabledBit');
          });
      },
    },
  };
</script>
